document.addEventListener( 'DOMContentLoaded', function () {
  const videoItems = document.querySelectorAll( '.videos__item' );

  videoItems.forEach( item => {
    const link = item.querySelector( '.videos__file' );
    const modal = item.querySelector( '.videos__item-modal' );
    const video = modal?.querySelector( 'video' );
    const closeBtn = modal?.querySelector( 'button' );

    if ( link && modal && video && closeBtn ) {
      link.addEventListener( 'click', ( e ) => {
        e.preventDefault();
        modal.classList.add( 'active' );
        video.play();
      } );

      closeBtn.addEventListener( 'click', () => {
        modal.classList.remove( 'active' );
        video.pause();
      } );
    }
  } );
} );
